import React, { useEffect, useState } from "react";
import { Button, Card, ConfigProvider, message, Spin } from "antd";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./termsConditions.css";
import { callApi } from "../../api/apiCaller";
import { routes } from "../../api/routes";
import Loader from "../../components/loader/loader";

const TermsConditions = () => {
  const [content, setContent] = useState("");
  const [termsId, setTermsId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const fetchTerms = () => {
    callApi(
      "GET",
      routes.getTermsConditions,
      null,
      setLoading,
      (res) => {
        if (res.status === 200) {
          const termsList = res.data?.data || [];
          if (termsList.length > 0) {
            const terms = termsList[0];
            setContent(terms.data || "");
            setTermsId(terms._id);
          } else {
            message.warning("No terms and conditions found");
          }
        }
      },
      (error) => {
        message.error("Failed to load Terms & Conditions");
      }
    );
  };

  const saveTerms = () => {
    if (!content.trim()) {
      message.warning("Please enter terms and conditions content");
      return;
    }

    if (!termsId) {
      message.error("Terms ID not found");
      return;
    }

    const body = { data: content };

    callApi(
      "PATCH",
      `${routes.updateTermsConditions}/${termsId}`,
      body,
      setSaving,
      (res) => {
        if (res.status === 200) {
          message.success("Terms & Conditions updated successfully");
          fetchTerms();
        }
      },
      (error) => {
        message.error("Failed to update Terms & Conditions");
      }
    );
  };

  useEffect(() => {
    fetchTerms();
  }, []);

  return (
    <ConfigProvider theme={{ token: { colorPrimary: "#555BDF" } }}>
      <div className="terms-page-container">
        <Loader loading={loading} />
        <Card
          className="terms-card"
          title={<span className="terms-title">Terms & Conditions</span>}
          extra={
            <Button
              type="primary"
              onClick={saveTerms}
              loading={saving}
              disabled={loading || !termsId}
            >
              Save Changes
            </Button>
          }
        >
          {loading ? (
            <div className="terms-loader">
              <Spin />
            </div>
          ) : (
            <ReactQuill
              theme="snow"
              value={content}
              onChange={setContent}
              className="terms-editor"
              placeholder="Enter terms and conditions content..."
            />
          )}
        </Card>
      </div>
    </ConfigProvider>
  );
};

export default TermsConditions;
